// extracted by mini-css-extract-plugin
export var footer = "_ma-0";
export var inherit = "_ma-1";
export var input = "_ma-2";
export var modalContent = "_ma-3";
export var quillEditor = "_ma-4";
export var subtitle = "_ma-5";